export default __webpack_public_path__ + "static/features-link-icon2.url-c1937c2a3069d1a47a34e5d916c1f441.svg";